import type { InGameMerchAbcKey } from '@fanduel/rewards-hub-client/in-game-merch';
import { useStore } from '@/store/useStore';
import {
  getExperimentValue,
  IN_GAME_MERCH_EXPERIMENT,
} from '@/utilities/logger/amplitude/experiments/getExperimentValue';
import { useExperimentExposure } from '@/utilities/logger/amplitude/experiments/experimentExposure';

const IN_GAME_MERCH_CONTROL_VALUE = 'control';

export const useInGameMerchFeatureFlag = () => {
  const amplitudeExperiments = useStore((s) => s.amplitudeExperiments);
  useExperimentExposure(IN_GAME_MERCH_EXPERIMENT);

  const variant = getExperimentValue(
    amplitudeExperiments,
    IN_GAME_MERCH_EXPERIMENT,
  );
  const enabled = Boolean(variant) && variant !== IN_GAME_MERCH_CONTROL_VALUE;

  return {
    enabled,
    // The orchestrator picks the popup variant (e.g. toasts only) from this.
    abcKey: enabled ? (variant as InGameMerchAbcKey) : undefined,
  };
};
